import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CaseModal, { CaseDetail } from '@/components/feature/CaseModal';

const allCases: (CaseDetail & { category: string; year: string; featured: boolean })[] = [
  {
    id: 1,
    titleKey: 'cases.c1.title',
    typeKey: 'cases.c1.type',
    descKey: 'cases.c1.desc',
    category: 'web',
    tags: ['React', 'Node.js', 'Shopify'],
    year: '2024',
    img: 'https://readdy.ai/api/search-image?query=luxury%20fashion%20ecommerce%20website%20interface%20on%20laptop%20screen%2C%20elegant%20dark%20teal%20and%20gold%20color%20scheme%2C%20product%20grid%20layout%2C%20modern%20minimal%20design%2C%20high%20end%20retail%20digital%20experience%2C%20clean%20white%20background%20studio%20photography&width=800&height=500&seq=case1&orientation=landscape',
    featured: true,
    clientKey: 'cases.c1.client',
    challengeKey: 'cases.c1.challenge',
    solutionKey: 'cases.c1.solution',
    resultsKeys: ['cases.c1.result1', 'cases.c1.result2', 'cases.c1.result3', 'cases.c1.result4'],
  },
  {
    id: 2,
    titleKey: 'cases.c2.title',
    typeKey: 'cases.c2.type',
    descKey: 'cases.c2.desc',
    category: 'app',
    tags: ['React Native', 'Supabase', 'AI'],
    year: '2024',
    img: 'https://readdy.ai/api/search-image?query=medical%20appointment%20mobile%20app%20interface%20on%20smartphone%2C%20clean%20white%20and%20teal%20color%20scheme%2C%20doctor%20patient%20booking%20UI%2C%20modern%20healthcare%20digital%20product%2C%20minimal%20flat%20design%2C%20warm%20cream%20background&width=800&height=500&seq=case2&orientation=landscape',
    featured: false,
    clientKey: 'cases.c2.client',
    challengeKey: 'cases.c2.challenge',
    solutionKey: 'cases.c2.solution',
    resultsKeys: ['cases.c2.result1', 'cases.c2.result2', 'cases.c2.result3', 'cases.c2.result4'],
  },
  {
    id: 3,
    titleKey: 'cases.c3.title',
    typeKey: 'cases.c3.type',
    descKey: 'cases.c3.desc',
    category: 'enterprise',
    tags: ['Vue.js', 'Python', 'PostgreSQL'],
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=financial%20dashboard%20analytics%20software%20interface%20on%20desktop%20monitor%2C%20dark%20navy%20teal%20color%20scheme%20with%20amber%20gold%20charts%20and%20graphs%2C%20data%20visualization%20SaaS%20product%2C%20professional%20enterprise%20software%20UI%2C%20clean%20modern%20design&width=800&height=500&seq=case3&orientation=landscape',
    featured: false,
    clientKey: 'cases.c3.client',
    challengeKey: 'cases.c3.challenge',
    solutionKey: 'cases.c3.solution',
    resultsKeys: ['cases.c3.result1', 'cases.c3.result2', 'cases.c3.result3', 'cases.c3.result4'],
  },
  {
    id: 4,
    titleKey: 'cases.c4.title',
    typeKey: 'cases.c4.type',
    descKey: 'cases.c4.desc',
    category: 'web',
    tags: ['Next.js', 'Tailwind', 'Stripe'],
    year: '2024',
    img: 'https://readdy.ai/api/search-image?query=modern%20real%20estate%20property%20listing%20website%20on%20desktop%20screen%2C%20clean%20white%20and%20warm%20beige%20color%20scheme%2C%20property%20cards%20grid%20layout%2C%20professional%20real%20estate%20digital%20platform%2C%20elegant%20minimal%20UI%20design%2C%20studio%20photography&width=800&height=500&seq=case4&orientation=landscape',
    featured: false,
    clientKey: 'cases.c4.client',
    challengeKey: 'cases.c4.challenge',
    solutionKey: 'cases.c4.solution',
    resultsKeys: ['cases.c4.result1', 'cases.c4.result2', 'cases.c4.result3', 'cases.c4.result4'],
  },
  {
    id: 5,
    titleKey: 'cases.c5.title',
    typeKey: 'cases.c5.type',
    descKey: 'cases.c5.desc',
    category: 'app',
    tags: ['Flutter', 'Firebase', 'ML'],
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=fitness%20tracking%20mobile%20app%20interface%20on%20smartphone%2C%20energetic%20dark%20teal%20and%20amber%20color%20scheme%2C%20workout%20dashboard%20with%20charts%20and%20progress%20rings%2C%20modern%20sports%20health%20app%20UI%2C%20clean%20minimal%20design%2C%20warm%20background&width=800&height=500&seq=case5&orientation=landscape',
    featured: false,
    clientKey: 'cases.c5.client',
    challengeKey: 'cases.c5.challenge',
    solutionKey: 'cases.c5.solution',
    resultsKeys: ['cases.c5.result1', 'cases.c5.result2', 'cases.c5.result3', 'cases.c5.result4'],
  },
  {
    id: 6,
    titleKey: 'cases.c6.title',
    typeKey: 'cases.c6.type',
    descKey: 'cases.c6.desc',
    category: 'enterprise',
    tags: ['React', 'Java', 'AWS'],
    year: '2023',
    img: 'https://readdy.ai/api/search-image?query=enterprise%20supply%20chain%20management%20system%20dashboard%20on%20large%20monitor%2C%20professional%20dark%20teal%20interface%20with%20data%20tables%20and%20logistics%20maps%2C%20corporate%20software%20UI%2C%20clean%20modern%20enterprise%20design%2C%20warm%20neutral%20background&width=800&height=500&seq=case6&orientation=landscape',
    featured: false,
    clientKey: 'cases.c6.client',
    challengeKey: 'cases.c6.challenge',
    solutionKey: 'cases.c6.solution',
    resultsKeys: ['cases.c6.result1', 'cases.c6.result2', 'cases.c6.result3', 'cases.c6.result4'],
  },
];

const extraTranslations: Record<string, Record<string, string>> = {
  en: {
    'cases.c4.title': 'HomeNest Real Estate Platform',
    'cases.c4.type': 'Website Development',
    'cases.c4.desc': 'A premium property listing and search platform for a leading real estate agency, featuring advanced filters, virtual tours, and mortgage calculators.',
    'cases.c4.client': 'HomeNest Realty Pte Ltd',
    'cases.c4.challenge': 'The agency relied on outdated listing portals with poor UX and no differentiation. They needed a branded platform with advanced search, virtual tours, and mortgage tools to attract high-net-worth buyers.',
    'cases.c4.solution': 'We delivered a Next.js platform with server-side rendering for SEO, integrated 3D virtual tour support, an AI-powered property recommendation engine, and a built-in mortgage calculator connected to live bank rates.',
    'cases.c4.result1': 'Organic search traffic increased by 220% in 6 months',
    'cases.c4.result2': 'Lead conversion rate improved from 1.2% to 4.7%',
    'cases.c4.result3': 'Average session duration increased by 3.5 minutes',
    'cases.c4.result4': "Featured in PropertyGuru's Top 10 PropTech Innovations 2024",
    'cases.c5.title': 'FitPulse Fitness App',
    'cases.c5.type': 'Mobile App Development',
    'cases.c5.desc': 'An AI-powered personal fitness companion with workout planning, nutrition tracking, and real-time coaching, reaching 50K downloads in the first month.',
    'cases.c5.client': 'FitPulse Inc.',
    'cases.c5.challenge': 'The fitness market was saturated with generic apps. The client wanted an AI-powered coach that adapts to individual fitness levels, integrates with wearables, and provides real-time form correction using the phone camera.',
    'cases.c5.solution': 'We built a Flutter app with on-device ML models for real-time pose estimation, Firebase for real-time sync across devices, and a personalized workout engine that adapts plans based on performance data and recovery metrics.',
    'cases.c5.result1': '50,000 downloads in the first month post-launch',
    'cases.c5.result2': '78% of users reported visible fitness improvements within 8 weeks',
    'cases.c5.result3': 'Average daily active usage of 24 minutes per user',
    'cases.c5.result4': 'Featured as App of the Day on the App Store in 3 countries',
    'cases.c6.title': 'LogiChain Supply System',
    'cases.c6.type': 'Enterprise Software',
    'cases.c6.desc': 'An end-to-end supply chain management platform for a multinational manufacturer, reducing logistics costs by 30% and improving delivery accuracy to 99.5%.',
    'cases.c6.client': 'GlobalManu Corp',
    'cases.c6.challenge': 'The manufacturer operated across 12 countries with siloed supply chain systems, causing inventory mismatches, delayed shipments, and a 15% logistics cost overrun annually. Real-time visibility was non-existent.',
    'cases.c6.solution': 'We architected a unified supply chain platform on AWS with React frontend and Java microservices, featuring real-time IoT tracking, predictive demand forecasting, automated PO generation, and a supplier collaboration portal.',
    'cases.c6.result1': 'Logistics costs reduced by 30% in the first year',
    'cases.c6.result2': 'On-time delivery accuracy improved from 82% to 99.5%',
    'cases.c6.result3': 'Inventory holding costs reduced by 25% through demand forecasting',
    'cases.c6.result4': 'Full visibility across 12 countries and 200+ suppliers in real time',
  },
  zh: {
    'cases.c4.title': 'HomeNest 房产平台',
    'cases.c4.type': '网站开发',
    'cases.c4.desc': '为领先房产中介打造的高端房源展示与搜索平台，支持高级筛选、虚拟看房及房贷计算器，大幅提升用户转化率。',
    'cases.c4.client': 'HomeNest 房产中介',
    'cases.c4.challenge': '中介依赖老旧房产门户，用户体验差且缺乏品牌差异化。他们需要一个自有平台，配备高级搜索、虚拟看房和房贷工具，以吸引高净值买家。',
    'cases.c4.solution': '我们交付了基于 Next.js 的服务端渲染平台，集成 3D 虚拟看房、AI 房源推荐引擎，以及接入实时银行利率的房贷计算器，全面提升 SEO 与用户体验。',
    'cases.c4.result1': '6 个月内自然搜索流量增长 220%',
    'cases.c4.result2': '线索转化率从 1.2% 提升至 4.7%',
    'cases.c4.result3': '平均访问时长增加 3.5 分钟',
    'cases.c4.result4': '入选 PropertyGuru 2024 年度十大 PropTech 创新',
    'cases.c5.title': 'FitPulse 健身应用',
    'cases.c5.type': '移动应用开发',
    'cases.c5.desc': 'AI 驱动的个人健身助手，涵盖训练计划、营养追踪与实时教练功能，上线首月下载量突破 5 万。',
    'cases.c5.client': 'FitPulse 健身科技',
    'cases.c5.challenge': '健身应用市场同质化严重。客户希望打造一款 AI 私教应用，能根据个人体能自适应调整，接入可穿戴设备，并通过手机摄像头实时纠正动作姿势。',
    'cases.c5.solution': '我们使用 Flutter 开发应用，集成端侧 ML 模型实现实时姿态估计，Firebase 实现多设备实时同步，个性化训练引擎根据表现数据与恢复指标动态调整计划。',
    'cases.c5.result1': '上线首月下载量突破 5 万',
    'cases.c5.result2': '78% 的用户反馈 8 周内体能明显改善',
    'cases.c5.result3': '用户日均活跃使用时长 24 分钟',
    'cases.c5.result4': '在 3 个国家 App Store 获评每日精选应用',
    'cases.c6.title': 'LogiChain 供应链系统',
    'cases.c6.type': '企业软件开发',
    'cases.c6.desc': '为跨国制造商打造的端到端供应链管理平台，物流成本降低 30%，配送准确率提升至 99.5%。',
    'cases.c6.client': 'GlobalManu 跨国制造集团',
    'cases.c6.challenge': '该制造商在 12 个国家运营，供应链系统各自为政，导致库存错配、发货延误，每年物流成本超支 15%，全链路可视化几乎为零。',
    'cases.c6.solution': '我们在 AWS 上构建统一供应链平台，React 前端 + Java 微服务后端，实现 IoT 实时追踪、预测性需求预测、自动采购单生成，以及供应商协作门户。',
    'cases.c6.result1': '首年物流成本降低 30%',
    'cases.c6.result2': '准时交货率从 82% 提升至 99.5%',
    'cases.c6.result3': '需求预测使库存持有成本降低 25%',
    'cases.c6.result4': '实现 12 个国家、200+ 供应商的实时全链路可视化',
  },
};

export default function CasesPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');
  const [visible, setVisible] = useState(false);
  const [selectedCase, setSelectedCase] = useState<typeof allCases[0] | null>(null);

  const lang = i18n.language === 'zh' ? 'zh' : 'en';

  const et = (key: string) =>
    extraTranslations[lang]?.[key] ?? extraTranslations['en']?.[key] ?? key;

  const getTitle = (c: typeof allCases[0]) =>
    extraTranslations['en'][c.titleKey] ? et(c.titleKey) : t(c.titleKey);
  const getType = (c: typeof allCases[0]) =>
    extraTranslations['en'][c.typeKey] ? et(c.typeKey) : t(c.typeKey);
  const getDesc = (c: typeof allCases[0]) =>
    extraTranslations['en'][c.descKey] ? et(c.descKey) : t(c.descKey);
  const getText = (key: string) =>
    extraTranslations['en'][key] ? et(key) : t(key);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const filters = [
    { key: 'all', label: t('cases.page.filter.all') },
    { key: 'web', label: t('cases.page.filter.web') },
    { key: 'app', label: t('cases.page.filter.app') },
    { key: 'enterprise', label: t('cases.page.filter.enterprise') },
  ];

  const filtered = activeFilter === 'all'
    ? allCases
    : allCases.filter((c) => c.category === activeFilter);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* Header */}
      <header className="bg-[#1e3a4a] text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 h-[72px] flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-base"></i>
            <span className="text-sm font-medium">{t('cases.page.back')}</span>
          </button>
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/d423d7259cd6886cdb573e095a6b9999/a48c44a5812fde7aa1b743301ff8f67a.png"
              alt="Rise Phoenix Logo"
              className="h-9 w-auto object-contain brightness-200"
            />
            <span className="text-white font-bold text-lg tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>
              Rise Phoenix
            </span>
          </div>
          <button
            onClick={() => i18n.changeLanguage(i18n.language === 'zh' ? 'en' : 'zh')}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-white/30 text-white/80 hover:text-white hover:border-white text-xs font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-translate-2 text-sm"></i>
            <span>{i18n.language === 'zh' ? 'EN' : '中文'}</span>
          </button>
        </div>
      </header>

      {/* Hero */}
      <section
        className="relative py-20 md:py-28 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #1e3a4a 0%, #2d5568 60%, #1e3a4a 100%)' }}
      >
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20geometric%20pattern%20with%20subtle%20grid%20lines%20and%20dots%2C%20dark%20teal%20navy%20background%2C%20minimal%20tech%20texture%2C%20professional%20digital%20design%20background%2C%20very%20subtle%20and%20understated&width=1440&height=400&seq=casehero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className={`relative max-w-7xl mx-auto px-6 md:px-10 text-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-500/20 border border-amber-400/30 mb-6">
            <i className="ri-briefcase-4-line text-amber-400 text-sm"></i>
            <span className="text-amber-300 text-xs font-semibold tracking-wider uppercase">{t('cases.badge')}</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('cases.page.title')}
          </h1>
          <p className="text-white/65 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            {t('cases.page.desc')}
          </p>
          <div className="flex items-center justify-center gap-10 mt-12">
            {[
              { num: '150+', label: t('services.stat1.label') },
              { num: '98%', label: t('services.stat2.label') },
              { num: '8+', label: t('services.stat3.label') },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-amber-400 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {stat.num}
                </div>
                <div className="text-white/55 text-xs font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filter */}
      <section className="sticky top-0 z-30 bg-white border-b border-[#f0ebe0]">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-2 py-4 overflow-x-auto">
            {filters.map((f) => (
              <button
                key={f.key}
                onClick={() => setActiveFilter(f.key)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeFilter === f.key
                    ? 'bg-[#1e3a4a] text-white'
                    : 'bg-[#f5f0e8] text-[#555] hover:bg-[#ede8de]'
                }`}
              >
                {f.label}
              </button>
            ))}
            <span className="ml-auto text-[#999] text-sm whitespace-nowrap shrink-0">
              {filtered.length} {lang === 'zh' ? '个项目' : 'projects'}
            </span>
          </div>
        </div>
      </section>

      {/* Cases Grid */}
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filtered.map((c, index) => (
              <div
                key={c.id}
                onClick={() => setSelectedCase(c)}
                className="group bg-white rounded-2xl overflow-hidden border border-[#f0ebe0] hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <div className="relative w-full h-52 overflow-hidden">
                  <img
                    src={c.img}
                    alt={getTitle(c)}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {c.featured && (
                    <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-amber-500 text-white text-xs font-bold">
                      {lang === 'zh' ? '精选' : 'Featured'}
                    </div>
                  )}
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-black/40 text-white text-xs font-medium">
                    {c.year}
                  </div>
                  {/* Hover overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 text-[#1e3a4a] text-xs font-semibold px-4 py-2 rounded-full flex items-center gap-1.5">
                      <i className="ri-eye-line"></i>
                      <span>{t('cases.modal.view')}</span>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <span className="inline-block px-3 py-1 rounded-full bg-amber-100 text-amber-700 text-xs font-semibold mb-3">
                    {getType(c)}
                  </span>
                  <h3 className="text-[#1e3a4a] text-lg font-bold mb-2 leading-snug" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {getTitle(c)}
                  </h3>
                  <p className="text-[#666] text-sm leading-relaxed mb-4">{getDesc(c)}</p>
                  <div className="flex flex-wrap gap-2">
                    {c.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 rounded-full bg-[#f5f0e8] text-[#1e3a4a] text-xs font-medium">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-24 bg-[#FFF9F0]">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a4a] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t('cases.page.cta.title')}
          </h2>
          <p className="text-[#666] text-base leading-relaxed mb-8">{t('cases.page.cta.desc')}</p>
          <button
            onClick={() => { navigate('/'); setTimeout(() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }), 300); }}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-amber-500 hover:bg-amber-600 text-white font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <span>{t('cases.page.cta.btn')}</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </section>

      {/* Footer mini */}
      <footer className="bg-[#1e3a4a] py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <p className="text-white/40 text-xs">{t('footer.copyright')}</p>
        </div>
      </footer>

      {/* Case Modal */}
      <CaseModal
        caseItem={selectedCase}
        onClose={() => setSelectedCase(null)}
        getTitle={getTitle}
        getType={getType}
        getDesc={getDesc}
        getText={getText}
      />
    </div>
  );
}
